var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.865 1.755L7.745 3.515C7.865 3.76 8.185 3.995 8.455 4.04L10.05 4.305C11.07 4.475 11.31 5.215 10.575 5.945L9.335 7.185C9.125 7.395 9.01 7.8 9.075 8.09L9.43 9.625C9.71 10.84 9.065 11.31 7.99 10.675L6.495 9.79C6.225 9.63 5.78 9.63 5.505 9.79L4.01 10.675C2.94 11.31 2.29 10.835 2.57 9.625L2.925 8.09C2.99 7.8 2.875 7.395 2.665 7.185L1.425 5.945C0.695 5.215 0.93 4.475 1.95 4.305L3.545 4.04C3.81 3.995 4.13 3.76 4.25 3.515L5.13 1.755C5.61 0.8 6.39 0.8 6.865 1.755Z",
    fill: "#F5A623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0,
    d: "M12 0H0V12H12V0Z",
    fill: "#F5A623"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRating);
export default __webpack_public_path__ + "static/media/star-rating.254740a7fb8119bb0ade3dcbaaa275ad.svg";
export { ForwardRef as ReactComponent };